import { connect } from 'react-redux';
import CardsUpdate from './index';
import { mapStateToProps, mapDispatchToProps } from './index.props';

export default connect(mapStateToProps, mapDispatchToProps)(CardsUpdate);
